import { useAsync } from '@tiger/hooks';
import React from 'react';
import { Navigate, Route } from 'react-router';
import AnimatedRouter from 'components/AnimatedRouter';
import Card from 'components/Card';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
// 身份验证
import ConfirmOptions from './components/ConfirmAccount/Options';
import Verify from './components/ConfirmAccount/Verify';
import VerifyID from './components/ConfirmAccount/VerifyID';
import ConfirmPwd from './components/ConfirmPwd';
import ModifySuccess from './components/ModifySuccess';
// 两步验证
import FAInstall from './modules/2FA/Install';
import FAInstallBind from './modules/2FA/Install/Bind';
import FAInstallDownload from './modules/2FA/Install/Download';
import FAInstallVerify from './modules/2FA/Install/Verify';
import FAUnInstall from './modules/2FA/UnInstall';
// 激活邮箱
import ActiveEmail from './modules/ActiveEmail';
import ActiveEmailConfirm from './modules/ActiveEmail/Confirm';
// 绑定手机号邮箱
import BindAccount from './modules/BindAccount';
import BindSuccess from './modules/BindAccount/modules/BindSuccess';
import VerifyIdentity from './modules/BindAccount/modules/VerifyIdentity';
// 首页面板
import Dashboard from './modules/Dashboard';
// IB账户获取登录名和密码
import LinkAccount from './modules/Link';
import LinkSuccess from './modules/Link/Success';
// 修改邮箱
import ModifyEmail from './modules/Modify/Email';
import EmailChangeModule from './modules/Modify/Email/ChangeModule';
// 修改密码
import ModifyPassword from './modules/Modify/Password';
import ChangePassword from './modules/Modify/Password/ChangePassword';
// 修改手机号
import ModifyPhone from './modules/Modify/Phone';
import PhoneChangeModule from './modules/Modify/Phone/ChangeModule';
// 受信联系人
import SetPassword from './modules/SetPassword';
import Trust from './modules/Trust';
// 更新密码
import UpgradeTips from './modules/Upgrade/Tips';
import store from './store';

const Security = () => {
    const [state, getData] = useAsync(store.getSettings, state => {
        if (!state.loading && !state.error) {
            store.updateOtpEnable(state.data?.data.otp_enable);
        }
    });

    const render = () => {
        if (state.loading) {
            return <Loading />;
        }

        if (state.error) {
            return <ErrorBox error={state.error} onClick={() => getData()} />;
        }

        return (
            <AnimatedRouter timeout={300}>
                <Route index element={<Dashboard />} />
                {/* 修改手机号 */}
                <Route path="modify/phone" element={<ModifyPhone />}>
                    <Route index element={<Navigate to="1" replace />} />
                    <Route path="1" element={<ConfirmPwd type="modifyPhone" />} />
                    <Route path="2" element={<ConfirmOptions type="modifyPhone" />} />
                    <Route path="2/msg" element={<Verify type="modifyPhone" method="msg" />} />
                    <Route path="2/mail" element={<Verify type="modifyPhone" method="mail" />} />
                    <Route path="2/id" element={<VerifyID type="modifyPhone" />} />
                    <Route path="3" element={<PhoneChangeModule />} />
                    <Route path="4" element={<ModifySuccess type="modifyPhone" />} />
                    <Route path="*" element={<Navigate to="1" replace />} />
                </Route>
                {/* 修改邮箱 */}
                <Route path="modify/email" element={<ModifyEmail />}>
                    <Route index element={<Navigate to="1" replace />} />
                    <Route path="1" element={<ConfirmPwd type="modifyEmail" />} />
                    <Route path="2" element={<ConfirmOptions type="modifyEmail" />} />
                    <Route path="2/msg" element={<Verify type="modifyEmail" method="msg" />} />
                    <Route path="2/mail" element={<Verify type="modifyEmail" method="mail" />} />
                    <Route path="2/id" element={<VerifyID type="modifyEmail" />} />
                    <Route path="3" element={<EmailChangeModule />} />
                    <Route path="4" element={<ModifySuccess type="modifyEmail" />} />
                    <Route path="*" element={<Navigate to="1" replace />} />
                </Route>
                {/* 修改密码 */}
                <Route path="modify/password" element={<ModifyPassword type="modifyPassword" />}>
                    <Route index element={<Navigate to="1" replace />} />
                    <Route path="1" element={<ConfirmPwd type="modifyPassword" />} />
                    <Route path="2" element={<ConfirmOptions type="modifyPassword" />} />
                    <Route path="2/msg" element={<Verify type="modifyPassword" method="msg" />} />
                    <Route path="2/mail" element={<Verify type="modifyPassword" method="mail" />} />
                    <Route path="2/id" element={<VerifyID type="modifyPassword" />} />
                    <Route path="3" element={<ChangePassword type="password" />} />
                    <Route path="4" element={<ModifySuccess type="modifyPassword" />} />
                    <Route path="*" element={<Navigate to="1" replace />} />
                </Route>
                {/* 更新密码 */}
                <Route path="upgrade/password" element={<ModifyPassword type="upgradePassword" />}>
                    <Route index element={<Navigate to="tips" replace />} />
                    <Route path="tips" element={<UpgradeTips />} />
                    <Route path="1" element={<ConfirmOptions type="upgradePassword" />} />
                    <Route path="1/msg" element={<Verify type="upgradePassword" method="msg" />} />
                    <Route path="1/mail" element={<Verify type="upgradePassword" method="mail" />} />
                    <Route path="1/id" element={<VerifyID type="upgradePassword" />} />
                    <Route path="2" element={<ChangePassword type="upgradePassword" />} />
                    <Route path="3" element={<ModifySuccess type="upgradePassword" />} />
                    <Route path="*" element={<Navigate to="tips" replace />} />
                </Route>
                {/* 激活邮箱 */}
                <Route path="active/email" element={<ActiveEmail />}>
                    <Route index element={<Navigate to="1" replace />} />
                    <Route path="1" element={<ActiveEmailConfirm />} />
                    <Route path="2" element={<ModifySuccess type="activeEmail" />} />
                    <Route path="*" element={<Navigate to="1" replace />} />
                </Route>
                {/* 绑定邮箱手机号 */}
                {(['email', 'phone'] as const).map(type => (
                    <Route
                        path={`bind/${type}`}
                        key={type}
                        element={<BindAccount type={type === 'email' ? 'bindEmail' : 'bindPhone'} />}>
                        <Route index element={<Navigate to="1" replace />} />
                        <Route path="1" element={<ConfirmPwd type={type === 'phone' ? 'bindPhone' : 'bindEmail'} />} />
                        <Route path="2" element={<VerifyIdentity />} />
                        <Route path="3" element={<BindSuccess type={type} />} />
                        <Route path="*" element={<Navigate to="1" replace />} />
                    </Route>
                ))}
                {/** ib账户密码获取 */}
                <Route path="link" element={<LinkAccount />}>
                    <Route index element={<Navigate to="1" replace />} />
                    <Route path="1" element={<ConfirmPwd type="linkAccount" />} />
                    <Route path="2" element={<ConfirmOptions type="linkAccount" />} />
                    <Route path="2/msg" element={<Verify type="linkAccount" method="msg" />} />
                    <Route path="2/mail" element={<Verify type="linkAccount" method="mail" />} />
                    <Route path="2/id" element={<VerifyID type="linkAccount" />} />
                    <Route path="3" element={<LinkSuccess />} />
                    <Route path="*" element={<Navigate to="1" replace />} />
                </Route>
                {/* 关闭和开启两步验证 */}
                <Route path="2fa/install" element={<FAInstall />}>
                    <Route index element={<Navigate to="1" replace />} />
                    <Route path="1" element={<FAInstallDownload />} />
                    <Route path="2" element={<ConfirmPwd type="mfaEnable" nextStep={3} />} />
                    <Route path="3" element={<ConfirmOptions type="mfaEnable" />} />
                    <Route path="3/msg" element={<Verify type="mfaEnable" method="msg" />} />
                    <Route path="3/mail" element={<Verify type="mfaEnable" method="mail" />} />
                    <Route path="3/id" element={<VerifyID type="mfaEnable" />} />
                    <Route path="4" element={<FAInstallBind />} />
                    <Route path="4/verify" element={<FAInstallVerify />} />
                    <Route path="*" element={<Navigate to="1" replace />} />
                </Route>
                <Route path="2fa/uninstall/" element={<FAUnInstall />} />
                <Route path="trust" element={<Trust />} />
                <Route path="set/password" element={<SetPassword />} />
                <Route path="*" element={<Navigate to="." replace />} />
            </AnimatedRouter>
        );
    };

    return (
        <Card page className="security-root">
            {render()}
        </Card>
    );
};

export default Security;
